import * as React from "react";
import { MessageSquareMore, MonitorSmartphone, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const processSteps = [{
  num: "01",
  title: "Yandex Direct B2B",
  description: "Configurazione di campagne ad alto impatto su Yandex Direct per intercettare la domanda consapevole nel mercato russo e CSI.",
  icon: MessageSquareMore,
  badge: null
}, {
  num: "02",
  title: "VKontakte Ecosystem",
  description: "Sviluppo di community e funnel di acquisizione su VK, il cuore pulsante del social marketing e della lead generation nativa.",
  icon: MonitorSmartphone,
  badge: "Targeting Avanzato"
}, {
  num: "03",
  title: "Conversione Lead",
  description: "Integrazione dei flussi di traffico in un sistema di conversione proprietario, garantendo lead qualificati e conformità FZ-152.",
  icon: CircleCheck,
  badge: null
}];
export default function ThreeSimpleSteps() {
  return <section data-section-id="224508" id="lead-generation-yandex-direct-e-vkontakte" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-6 text-foreground uppercase">
            Lead Generation: Yandex Direct e VKontakte
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Un'architettura integrata che trasforma la visibilità sui motori di ricerca e sui social network russi in opportunità di business concrete e misurabili.
          </p>
        </div>

        <div className="relative">
          {}
          <div className="hidden md:block absolute top-[4.5rem] left-[16.66%] right-[16.66%] h-px border-t-2 border-dashed border-secondary/30 z-0" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
            {processSteps.map((step, index) => <Card key={step.num} data-index={index} className="relative overflow-hidden rounded-none border-border/20 bg-card/40 backdrop-blur-md shadow-2xl transition-all hover:border-secondary/50 flex flex-col h-full">
                {}
                <span className="absolute -bottom-10 -right-6 text-[180px] font-bold leading-none text-primary/5 select-none pointer-events-none z-0 font-mono tracking-tighter" aria-hidden="true">
                  {step.num}
                </span>

                <CardHeader className="relative z-10 pb-4 pt-8 px-8">
                  <div className="w-16 h-16 rounded-sm bg-secondary/10 flex items-center justify-center mb-8 border border-secondary/20 shadow-lg">
                    <step.icon className="w-8 h-8 text-secondary" strokeWidth={1.5} />
                  </div>
                  <div className="flex items-center justify-between gap-4 flex-wrap">
                    <CardTitle className="text-2xl font-default font-bold text-foreground uppercase tracking-tight">
                      {step.title}
                    </CardTitle>
                    {step.badge && <Badge variant="default" className="rounded-none px-3 py-1 font-mono text-[10px] uppercase bg-primary text-primary-foreground shadow-md">
                        {step.badge}
                      </Badge>}
                  </div>
                </CardHeader>
                
                <CardContent className="relative z-10 px-8 pb-10 flex-grow">
                  <p className="text-muted-foreground font-sans leading-relaxed text-base">
                    {step.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}